import { render } from "./PageRender.vue?vue&type=template&id=540fc630"
import script from "./PageRender.vue?vue&type=script&lang=js"
export * from "./PageRender.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__